/**
 * Format a string with some args
 * By Joncky 22.06.13
 * @param {string} val
 */
// eslint-disable-next-line no-extend-native
String.prototype.formatWith = function () {
    let formatted = this
    for (const i in arguments) {
        formatted = formatted.replace('{' + i + '}', arguments[i])
    }
    return formatted
}